import VueI18n from "vue-i18n";
import Vue from "vue";

import { LOCALES, Locales } from "./locales";

import en from "./locale/en.json";
import ar from "./locale/ar.json";
import { Language } from "@/models/Language.d.ts";
import router, { updatePageTitle } from "@/router";

export const messages = {
    [Locales.EN]: en,
    [Locales.AR]: ar
};

export const defaultLocale = Locales.AR;

Vue.use(VueI18n);

export const i18n = new VueI18n({
    messages,
    locale: defaultLocale,
    fallbackLocale: defaultLocale
});

export const updateTranslation = function(language: Language) {
    i18n.locale = language.code;
    const html = window.document.documentElement;
    html.setAttribute("lang", language.code);
    html.setAttribute("dir", language.direction);

    try{
        updatePageTitle(router.currentRoute);
    } catch(err){
        console.error(err);
    }
};

updateTranslation({
    code: 'ar',
    name: 'العربية',
    direction: 'rtl',
    id: 'ar'
});


// Temp Hack Util to solve change language from english to Arabic when not loged in
export function changeDocumentLanguage() {
    const html = window.document.documentElement;
    const languageCode = html.getAttribute("lang");
    const currentLanguage = LOCALES.find(obj => obj.code === languageCode);
    let language;
    if(currentLanguage) {
        if (currentLanguage.code === Locales.EN) {
            language = LOCALES.find(obj => obj.code === Locales.AR);
        } else if (currentLanguage.code === Locales.AR) {
            language = LOCALES.find(obj => obj.code === Locales.EN);
        }
    } else {
        language = LOCALES[0];
    }
    updateTranslation(language as Language);
}
